import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=29c1e3a0"
import script from "./page-header.vue?vue&type=script&lang=ts"
export * from "./page-header.vue?vue&type=script&lang=ts"
import style0 from "./page-header.vue?vue&type=style&index=0&id=29c1e3a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports